export default __webpack_public_path__ + "static/media/Raider's Belt of World's Edge.3c8f6551.jpg";